import script from "./FlowComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FlowComponent.vue?vue&type=script&setup=true&lang=js"

import "./FlowComponent.vue?vue&type=style&index=0&id=b696823c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b696823c"]])

export default __exports__